module.exports = __webpack_public_path__ + "static/img/tech.ddd673ea.png";